import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user_id: '',
    user_domainName: '',
    user_email: '',
    user_name: '',
    accessToken: '',
    shop_name: '',
    platform: '',
    isProductAdded: false,
    desktop: {
        playlist_view: 1
    },
    mobile: {
        playlist_view: 1
    },
    is_mvm_connected: false,
    showLoader: false,
    loaderInfo: false,
    authToken: {},
    plan: {},
    is_plan_selected: false,
    socket: null,
    money_format: '',
    app_layout: 0,
    is_active_mvm_modal: false,
    digital_plan: {},
    profilePicture: '',
    planReValidate: 0, // re check plan validation after delete records,
    totalUploadingSize: 0,
    fileUploading: 0,
    recurring_interval: '',
    is_instagram_connected: false,
    active_instagram_id: '',
    isDummyShop: false,
}

export const userSlice = createSlice({
    name: 'user_info',
    initialState,
    reducers: {
        setUserInfo: (state, action) => {
            if (action.payload.userId)
                state.user_id = action.payload.userId
            if (action.payload.domainName)
                state.user_domainName = action.payload.domainName
            if (action.payload.email)
                state.user_email = action.payload.email
            if (action.payload.name || action.payload.domainName)
                state.user_name = action.payload.name || action.payload.domainName
            if (action.payload.platform)
                state.platform = action.payload.platform
            if (action.payload.isProductAdded)
                state.isProductAdded = action.payload.isProductAdded
            if (action.payload.desktop)
                state.desktop = action.payload.desktop
            if (action.payload.mobile && action.payload.mobile)
                state.mobile = action.payload.mobile
            if (action.payload.hasOwnProperty('is_mvm_connected'))
                state.is_mvm_connected = action.payload.is_mvm_connected
            if (action.payload.hasOwnProperty('authToken'))
                state.authToken = action.payload.authToken
            if (action.payload.hasOwnProperty('plan')) {
                state.plan = action.payload.plan
                state.is_plan_selected = true
            }
            if (action.payload.hasOwnProperty('digital_plan')) {
                state.digital_plan = action.payload.digital_plan
                state.is_plan_selected = true
            }
            if(action.payload.hasOwnProperty('is_plan_selected')) {
                state.is_plan_selected = action.payload.is_plan_selected
            }
            if(action.payload.hasOwnProperty('socket')) {
                state.socket = action.payload.socket;
            }
            if(action.payload.hasOwnProperty('money_format')) {
                state.money_format = action.payload.money_format;
            }
            if(action.payload.hasOwnProperty('app_layout')) {
                state.app_layout = action.payload.app_layout;
            }
            if(action.payload.hasOwnProperty('is_active_mvm_modal')) 
                state.is_active_mvm_modal = action.payload.is_active_mvm_modal;
            if(action.payload.hasOwnProperty('profilePicture')) {
                state.profilePicture = action.payload.profilePicture;
            }
            if(action.payload.hasOwnProperty('recurring_interval')) {
                state.recurring_interval = action.payload.recurring_interval;
            }
            if(action.payload.hasOwnProperty('is_instagram_connected')) {
                state.is_instagram_connected = action.payload.is_instagram_connected;
            }
            if(action.payload.hasOwnProperty('active_instagram_id')) {
                state.active_instagram_id = action.payload.active_instagram_id;
            }
            if (action.payload.hasOwnProperty('isDummyShop')) {
                state.isDummyShop = action.payload.isDummyShop;
            }
        },
        deleteUserInfo: (state, action) => {
            state.user_id = ''
            state.user_domainName = ''
            state.user_name = ''
            state.user_email = ''
            state.accessToken = ''
            state.shop_name = ''
            state.platform = ''
            state.isProductAdded = false
            state.is_mvm_connected = false
            state.authToken = {}
            state.plan = {}
            state.is_plan_selected = false
            state.socket = null
            state.is_active_mvm_modal = false
            state.digital_plan = {}
            state.planReValidate = 0
            state.totalUploadingSize = 0
            state.fileUploading = 0
            state.loaderInfo = false
            state.profilePicture = ''
            state.is_instagram_connected = false,
            state.active_instagram_id = ''
            state.isDummyShop = false
        },
        updateStoreConfig: (state, action) => {
            if (action.payload.access_token)
                state.accessToken = action.payload.access_token
            if (action.payload.shop_name)
                state.shop_name = action.payload.shop_name
        },
        updateFrontConfiguration: (state, action) => {
            if (action.payload.desktopPlaylist) {
                state.desktop = { ...state.desktop, playlist_view: action.payload.desktopPlaylist }
            }
            if (action.payload.mobilePlaylist) {
                state.mobile = { ...state.mobile, playlist_view: action.payload.mobilePlaylist }
            }
        },
        setLoader: (state, action) => {
            state.showLoader = action.payload
        },
        setLoaderInfo: (state, action) => {
            state.loaderInfo = action.payload
        },
        setPlanReValidate: (state, action) => {
            state.planReValidate = state.planReValidate + 1
        },
        setTotalUploadingSize: (state, action) => {
            state.totalUploadingSize = action.payload
        },
        setFileUploadingSize: (state, action) => {
            state.fileUploading = state.fileUploading + action.payload
            var percentageUpload = Math.floor(state.fileUploading / state.totalUploadingSize * 100)
            percentageUpload = percentageUpload > 100 ? 100 : percentageUpload
            state.loaderInfo = percentageUpload + '%'
        },
        resetFileUploading: (state) => {
            state.totalUploadingSize = 0
            state.fileUploading = 0
            state.loaderInfo = false
        }
    }
})

export const { setUserInfo, deleteUserInfo, updateStoreConfig, updateFrontConfiguration, setLoader, setLoaderInfo, setPlanReValidate, setTotalUploadingSize, setFileUploadingSize, resetFileUploading } = userSlice.actions

export default userSlice.reducer